module.exports = __webpack_public_path__ + "static/media/person-giving-water-herdy.f16021b3.svg";